export default {
  header: 'Tagi zdarzeń',
  empty: 'Nie utworzono jeszcze żadnych tagów zdarzeń.',
  confirmDeleteMessage: 'Zdarzenia, które mają ten tag, zachowają go.',
};
